import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { IProductEntry } from '../types/productEntry'
import { mapContentBlockToServiceDetails } from 'app/(main)/(catalog)/_components/product/ProductPage/ProductPage.utils'

interface IProductTag {
  fields?: {
    labelImage?: any
    [key: string]: any
  }
}

interface IDeliveryType {
  fields?: {
    deliveryTypeIcon?: any
    [key: string]: any
  }
}

function parseProductEntry(productEntry): IProductEntry {
  if (!productEntry?.fields) {
    return null
  }

  const { fields } = productEntry

  // Helper function to safely map arrays
  const safeMap = <T, R>(
    array: T[] | undefined,
    mapFn: (item: T) => R
  ): R[] => {
    return array?.map(mapFn).filter(Boolean) || []
  }

  return {
    productName: fields?.productName,
    productType: fields?.productType,
    productDescription: fields?.productDescriptionRichText,
    productSeo: fields?.seoModelRef?.fields || null,
    productHeroImages: fields?.productHeroImages,
    productTags: safeMap(fields?.productTags, (tag: IProductTag) => ({
      ...tag?.fields,
      labelImage: mapContentfulImageAsset(tag?.fields?.labelImage),
    })),
    productSlug: fields?.productSlug,
    urlSlug: fields?.urlSlug,
    fieldsConfiguration: fields?.productSelectionFields,
    ctaLabel: fields?.productInfoButtonTitle,
    moq: fields?.productInfoMoq,
    helpText: fields?.productInfoFooter,
    comingSoonState: fields?.comingSoonState,
    enableRequestAQuoteFlow: fields?.enableRequestAQuoteFlow,
    requestAQuoteFormPath: fields?.requestAQuoteFormPath,
    alternativeDtcPagePath: fields?.alternativeDtcPagePath,
    displayAlternativeDtcPath: fields?.displayAlternativeDtcPath,
    displayAlternativePlusPath: fields?.displayAlternativePlusPath,
    minimumQuoteQuantityOverride: fields?.minimumQuoteQuantityOverride,
    isPlusProductAvailable: fields?.plusProductAvailabilityPerRegion,
    productPlusEditorConfig: fields?.productPlusEditorConfig,
    extraQuoteQuantityOptions: fields?.extraQuoteQuantityOptions,
    productDeliveryTypes: safeMap(
      fields?.productDeliveryTypes,
      (entry: IDeliveryType) => ({
        ...entry.fields,
        deliveryTypeIcon: mapContentfulImageAsset(
          entry?.fields?.deliveryTypeIcon
        ),
      })
    ),
    productDeliveryDisclaimer: fields?.productDeliveryDisclaimer,
    onlineEditorUrl: fields?.onlineEditorUrl,
    correspondingPlusProductSku: fields?.correspondingPlusProductSku,
    productDetailsBadge: fields?.productDetailsBadge
      ? {
          title: fields.productDetailsBadge?.fields?.h1,
          image: mapContentfulImageAsset(
            fields.productDetailsBadge?.fields?.primaryImages?.[0]
          ),
          ctaUrl: fields.productDetailsBadge?.fields?.ctaLink,
        }
      : undefined,
    serviceDetails: safeMap(
      fields?.serviceDetails,
      mapContentBlockToServiceDetails
    ),
    breadcrumbsConfig: safeMap(
      fields?.breadcrumbs,
      (x: { fields: { ctaLabel: string; ctaLink: string } }) => ({
        name: x?.fields?.ctaLabel,
        path: x?.fields?.ctaLink,
      })
    ),
    hubspotPlusFormId: fields?.hubspotPlusFormId,
    customSizeNote: fields?.customSizeNote || null,
  }
}

export { parseProductEntry }
